import Vue from 'vue';
import purchaseTransformer from './../../transformers/purchase';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('RefreshStockProductsCustom');
  resolve(purchaseTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(purchaseTransformer.fetch(errors));
};

export default purchase => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/purchases', purchase)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/store.js